import { render, staticRenderFns } from "./TeamAdsIcon.vue?vue&type=template&id=0c732bbe"
import script from "./TeamAdsIcon.vue?vue&type=script&lang=js"
export * from "./TeamAdsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports